export const getContactName = (contact) =>
  [contact["First Name"], contact["Last Name"]].filter(Boolean).join(" ") ||
  contact["Email Address"] ||
  "Unnamed contact";

export const getContactKey = (contact, company) =>
  JSON.stringify([company, contact["Email Address"]]);

export const getContactValues = (contact) => ({
  firstName: contact["First Name"] || "",
  lastName: contact["Last Name"] || "",
  inviteeEmail: contact["Email Address"] || "",
  inviteePhoneNumber: String(contact.Phone || ""),
  inviteeCompany: contact.Company || "",
  inviteeCompanyAddress: contact["Company Address"] || "",
  inviteeCompanyPermission: contact["Company Permissions"] || "Default",
  inviteeProjectPermission: contact["Project Permissions"] || "Default",
});

export const getContactDetails = (values, contact = {}) => ({
  firstName: String(values.firstName || "").trim(),
  lastName: String(values.lastName || "").trim(),
  inviteeEmail: contact["Email Address"] || values.inviteeEmail.trim(),
  inviteePhoneNumber: String(values.inviteePhoneNumber || "").trim(),
  inviteeCompany: String(values.inviteeCompany || "").trim(),
  inviteeCompanyAddress: String(values.inviteeCompanyAddress || "").trim(),
  inviteeCompanyPermission: values.inviteeCompanyPermission,
  inviteeProjectPermission: values.inviteeProjectPermission,
});

export const getBulkEditDetails = (values, contacts) =>
  contacts.map((contact) => {
    const currentValues = getContactValues(contact);
    return getContactDetails(
      {
        ...currentValues,
        inviteeCompany:
          values.inviteeCompany?.trim() || currentValues.inviteeCompany,
        inviteeCompanyAddress:
          values.inviteeCompanyAddress?.trim() ||
          currentValues.inviteeCompanyAddress,
        inviteeCompanyPermission:
          values.inviteeCompanyPermission ||
          currentValues.inviteeCompanyPermission,
        inviteeProjectPermission:
          values.inviteeProjectPermission ||
          currentValues.inviteeProjectPermission,
      },
      contact,
    );
  });

export const getInvitationDetails = (contact) =>
  getContactDetails(getContactValues(contact), contact);

export const canManageContact = (accessLevel, contact) =>
  [2, 3].includes(Number(accessLevel)) &&
  contact["Company Permissions"] !== "Account Owner" &&
  contact["Project Permissions"] !== "Account Owner";

export const filterCompanies = (content = {}, search = "") => {
  const query = search.trim().toLowerCase();
  return Object.entries(content || {})
    .map(([company, contacts]) => ({
      company,
      contacts: (Array.isArray(contacts) ? contacts : []).filter((contact) =>
        [
          company,
          getContactName(contact),
          contact["Email Address"],
          contact.Phone,
          contact["Company Address"],
          contact["Company Permissions"],
          contact["Project Permissions"],
          contact.Status,
        ].some((value) =>
          String(value || "")
            .toLowerCase()
            .includes(query),
        ),
      ),
    }))
    .filter(({ contacts }) => contacts.length > 0)
    .sort((a, b) =>
      a.company.localeCompare(b.company, undefined, { sensitivity: "base" }),
    );
};

export const getErrorMessage = (_, fallback) => fallback;
